import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from './util.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class DcsBaseHttpService {
  httpOptions = {
    headers: new HttpHeaders()
  };
  constructor(private http: HttpClient,private readonly translate:TranslateService) { }

  setHeaderOtptions() {
    this.httpOptions.headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.httpOptions.headers = this.httpOptions.headers
      .set('X-BRAND', environment.xBrand);
  }

  get(path: string, version: string = '1.0', brand?: { xBrand: string, xClient: string }): Observable<any> {
    this.setHeaderOtptions();
    if (brand) {
      this.httpOptions.headers = this.httpOptions.headers.set('X-BRAND', brand.xBrand);
    }
    return this.http.get(`${path}`, this.httpOptions)
      .pipe(
        tap(data => this.log(data)),
        catchError(this.handleError)
      );
  }

  private log(data) {
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      this.translate.instant('otherTexts.somethingBadHappenedPleaseTryAgainLater'));
  }
}
